import { Link } from "react-router-dom";
import { BUSINESS } from "@/lib/api";
import { SocialLinks } from "@/components/site/SocialLinks";
import { NewsletterSignup } from "@/components/site/NewsletterSignup";

export const Footer = () => (
  <footer className="border-t border-[#E6E2DA] bg-[#F2EFE9]">
    <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-2 lg:grid-cols-4 lg:px-12">
      <div>
        <img src="/brand/logo.png" alt="Firm Foundations Construction LLC" className="h-24 w-auto rounded-lg" data-testid="footer-logo" />
        <p className="mt-4 max-w-xs text-sm text-[#5C5850]">Custom homes and custom concrete work. {BUSINESS.area}.</p>
        <SocialLinks className="mt-4" />
      </div>
      <div className="space-y-1 text-sm">
        <p className="eyebrow mb-2">Contact</p>
        <a href={BUSINESS.phoneHref} className="block font-semibold hover:text-[#A67C00]" data-testid="footer-phone">{BUSINESS.phone}</a>
        <a href={`mailto:${BUSINESS.email}`} className="block break-all hover:text-[#A67C00]" data-testid="footer-email">{BUSINESS.email}</a>
        <p className="text-[#5C5850]">{BUSINESS.address}</p>
      </div>
      <div className="space-y-1 text-sm">
        <p className="eyebrow mb-2">Links</p>
        <a href="#book" className="block hover:text-[#A67C00]" data-testid="footer-book-link">Book an estimate visit</a>
        <a href="#specials" className="block hover:text-[#A67C00]" data-testid="footer-specials-link">Specials</a>
        <Link to="/portal" className="block hover:text-[#A67C00]" data-testid="footer-portal-link">Customer & employee portal</Link>
      </div>
      <NewsletterSignup />
    </div>
    <div className="border-t border-[#E6E2DA] py-5 text-center text-xs text-[#8C877D]">
      <p className="font-serif-accent text-sm text-[#0E1F3F]">Strong Faith. Firm Foundations. Endless Integrity. — Matthew 7:24</p>
      <p className="mt-1">© {new Date().getFullYear()} {BUSINESS.name} LLC. All rights reserved.</p>
    </div>
  </footer>
);
